import { DetailedHTMLProps, FC, HTMLAttributes } from 'react'
import { cn } from '@bem-react/classname'
import { Memo } from '@/hoc/Memo'

import './styles/CompanyCodes.scss'
import { useTranslation } from 'react-i18next'

const cnCompanyCodes = cn('CompanyCodes')

export interface CompanyCodesSchema
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  companycodes: string[]
}

export const CompanyCodes: FC<CompanyCodesSchema> = Memo(
  ({ className, companycodes }: CompanyCodesSchema) => {
    const { t } = useTranslation(['translation', 'countries'])

    return (
      <>
        <div className={cnCompanyCodes(null, [className])}>
          <div className={cnCompanyCodes('title')}>
            {t('This customer has alredy this company:')}
          </div>
          <div className={cnCompanyCodes('list')}>
            {companycodes.map((code, index) => (
              <span key={index} className={cnCompanyCodes('code')}>
                {code}
              </span>
            ))}
          </div>

          <div className={cnCompanyCodes('title')}>
            {t('Are you sure to create new one?')}
          </div>
        </div>
      </>
    )
  },
)
